import Articles from "../screens/articles";
import AccountSignin from "../screens/account-signin";
import Admin from "../screens/admin";
import Training from "../screens/training";

export const COMMON_ROUTE = {
  home: {
    path: "/",
    component: Articles,
  },
  training: {
    path: "/training",
    component: Training,
  },
  accountSignin: {
    path: "/account-signin",
    component: AccountSignin,
  },
  admin: {
    path: "/admin",
    component: Admin,
  },
  login: {
    path: "/google-login",
    component: Training,
  },
};
